import {
    tss,
} from 'app/tss'

const general = 'general'
const fees = 'fees'

// Nested grid areas for general section
const status = 'status'
const validFrom = 'validFrom'
const validTo = 'validTo'
const cancellationDays = 'cancellationDays'
const cancellationDaysType = 'cancellationDaysType'
const manualBillingReview = 'manualBillingReview'
const comment = 'comment'

export default tss.create(({
    theme,
}) => {
    return {
        root: {
            backgroundColor: theme.palette.secondary[50],
            cursor: 'default',
        },
        gridWrapper: {
            display: 'grid',
            gridGap: theme.spacing(1),
            gridTemplateAreas: `
            "${general}"
            "${fees}"`,
            gridTemplateColumns: 'repeat(1, 1fr)',
        },
        general: {
            gridArea: general,
            display: 'grid',
            gap: `0 ${theme.spacing(4)}`,
            gridTemplateAreas: `
                "${status} ${validFrom} ${cancellationDays}" 
                "${status} ${validTo} ${cancellationDaysType}"
                ". ${manualBillingReview} ."
                "${comment} ${comment} ${comment}"
            `,
            gridTemplateColumns: 'repeat(3, 1fr)',
        },
        status: {
            gridArea: status,
        },
        validFrom: {
            gridArea: validFrom,
        },
        validTo: {
            gridArea: validTo,
        },
        cancellationDays: {
            gridArea: cancellationDays,
        },
        cancellationDaysType: {
            gridArea: cancellationDaysType,
        },
        manualBillingReview: {
            gridArea: manualBillingReview,
        },
        comment: {
            gridArea: comment,
        },
        fees: {
            gridArea: fees,
            gridTemplateColumns: '1fr !important',
        },
        commentColumn: {
            gridColumnEnd: 'span 3',
        },
    }
})
